import Image from 'next/image';

import { CloudinaryImageViewModel } from '@api/index';
import Markdown from '@components/utils/Markdown';
import Typography from '@components/Typography';

import {
  Container,
  Description,
  ImageWrapper,
  Label,
  TextContentWrapper,
} from './ItemStyle';

interface Props {
  image: CloudinaryImageViewModel;
  label: string;
  description: string;
}

const BuyingFromSeturFeature = ({ label, image, description }: Props) => {
  return (
    <Container>
      <ImageWrapper>
        <Image
          src={image?.url ?? ''}
          width={61}
          height={61}
          style={{ objectFit: 'contain' }}
          alt={image?.alt ?? label}
        />
      </ImageWrapper>
      <TextContentWrapper>
        <Label>
          <Typography color='D100' variant='Title5' weight='SemiBold'>
            {label}
          </Typography>
        </Label>
        <Description>
          <Markdown text={description} />
        </Description>
      </TextContentWrapper>
    </Container>
  );
};

export default BuyingFromSeturFeature;
